import React, { useState, useRef, useEffect } from 'react';
import { _T, C } from '../../../shared/theme';
import { s_PB, s_GC } from '../../../shared/styles';
import { saveGameScore } from '../../../shared/utils';

function playTone(freq = 880, duration = 0.25, pan = 0) {
  try {
    const ac = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ac.createOscillator();
    const gain = ac.createGain();
    const panner = ac.createStereoPanner ? ac.createStereoPanner() : null;
    osc.frequency.value = freq;
    osc.type = 'sine';
    gain.gain.setValueAtTime(0.4, ac.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ac.currentTime + duration);
    if (panner) { panner.pan.value = pan; osc.connect(panner); panner.connect(gain); }
    else { osc.connect(gain); }
    gain.connect(ac.destination);
    osc.start(); osc.stop(ac.currentTime + duration);
    setTimeout(() => ac.close(), (duration + 0.1) * 1000);
  } catch {}
}

function SoundReactGame({ lang, onBack }) {
  const nl = lang === 'nl';
  const [state, setState] = useState('idle');
  const [ms, setMs] = useState(null);
  const [scores, setScores] = useState([]);
  const [best, setBest] = useState(null);
  const timerRef = useRef(null);
  const startRef = useRef(null);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  const startRound = () => {
    setState('ready'); setMs(null);
    const delay = 1200 + Math.random() * 2800;
    timerRef.current = setTimeout(() => {
      setState('playing');
      startRef.current = Date.now();
      playTone(880, 0.4);
    }, delay);
  };

  const tap = () => {
    if (state === 'playing') {
      clearTimeout(timerRef.current);
      const t = Date.now() - startRef.current;
      setMs(t); setState('done');
      setScores(p => [t, ...p].slice(0, 5));
      if (!best || t < best) setBest(t);
      saveGameScore('soundreact', Math.max(1, 1000 - t));
      playTone(660, 0.1);
    } else if (state === 'ready') {
      clearTimeout(timerRef.current);
      setState('toosoon');
      playTone(200, 0.3);
    }
  };

  const avg = scores.length ? Math.round(scores.reduce((a, b) => a + b) / scores.length) : null;

  return (
    <div>
      <button onClick={onBack} style={{ background: 'none', border: 'none', color: C.silver, cursor: 'pointer', fontSize: 13, marginBottom: 12 }}>
        ← {nl ? 'Terug' : 'Back'}
      </button>
      <div style={{ ...s_GC(), display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, textAlign: 'center', marginBottom: 10 }}>
        <div><div style={{ fontSize: 11, color: C.silver }}>BEST</div><div style={{ fontSize: 22, color: C.teal, fontWeight: 700 }}>{best ? `${best}ms` : '–'}</div></div>
        <div><div style={{ fontSize: 11, color: C.silver }}>AVG</div><div style={{ fontSize: 22, color: _T.accent, fontWeight: 700 }}>{avg ? `${avg}ms` : '–'}</div></div>
      </div>
      <div onClick={tap} style={{ ...s_GC({ padding: '48px 20px', textAlign: 'center', cursor: 'pointer', marginBottom: 12 }), background: state === 'playing' ? '#2A9E8230' : state === 'toosoon' ? '#C0505018' : _T.bg4, transition: 'background 0.2s' }}>
        {state === 'idle'    && <><div style={{ fontSize: 52 }}>🔊</div><div style={{ color: C.silver, marginTop: 8 }}>{nl ? 'Tik om te starten' : 'Tap to start'}</div></>}
        {state === 'ready'   && <><div style={{ fontSize: 52 }}>🎧</div><div style={{ color: C.orange, fontWeight: 700, fontSize: 16, marginTop: 8 }}>{nl ? 'Luister...' : 'Listen...'}</div></>}
        {state === 'playing' && <><div style={{ fontSize: 52 }} className="popIn">🔔</div><div style={{ color: C.teal, fontSize: 22, fontWeight: 700, marginTop: 8 }}>{nl ? 'TIK NU!' : 'TAP NOW!'}</div></>}
        {state === 'done'    && <><div style={{ fontSize: 40, color: _T.accent, fontWeight: 200 }}>{ms}<span style={{ fontSize: 14, color: C.silver, marginLeft: 4 }}>ms</span></div>{best === ms && <div style={{ color: C.teal, fontSize: 13, marginTop: 4 }}>🏆 {nl ? 'Record!' : 'Record!'}</div>}<div style={{ color: C.silver, fontSize: 12, marginTop: 4 }}>{nl ? 'Tik opnieuw' : 'Tap again'}</div></>}
        {state === 'toosoon' && <><div style={{ fontSize: 48 }}>❌</div><div style={{ color: C.red, fontWeight: 700, marginTop: 8 }}>{nl ? 'Te vroeg!' : 'Too soon!'}</div></>}
      </div>
      {(state === 'idle' || state === 'toosoon') && (
        <button style={s_PB({ width: '100%' })} onClick={startRound}>{nl ? 'Start' : 'Start'}</button>
      )}
    </div>
  );
}

export default SoundReactGame;
